import { useMemo } from 'react';
import {
  DynamicFieldKey_Enum as DynamicFieldKey,
  DynamicFieldProperty_Enum,
  TemplateType_Slug,
} from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { TemplatorV2Queries } from '@frontend/api-templator-v2';
import { useAppScopeStore } from '@frontend/scope';
import { formatDynamicFieldKey } from '@frontend/string';
import { DEFAULT_TIME_EARLY } from './constants';
import { useTimeEarlyDynamicFields } from './use-time-early-dynamic-fields';

/**
 * this hook is used to get the dynamic fields for what is going to be used in the content-composer
 */

export const useDynamicFields = (templateTypeSlugs?: TemplateType_Slug[], timeEarly = DEFAULT_TIME_EARLY) => {
  const { selectedLocationIds: businessGroupIds } = useAppScopeStore();

  const { data = [] } = TemplatorV2Queries.useTemplateTypesList(
    {
      businessGroupIds,
      templateTypeSlugs,
    },
    {
      select: (response) => response?.templateTypes?.[0]?.dynamicFields,
    }
  );

  const { dynamicFieldOptionsMap, defaultDynamicFieldLabelMap } = useTimeEarlyDynamicFields(timeEarly);

  const dynamicFields = useMemo(
    () =>
      data.map((field) => {
        const fields = {
          val: field.key ?? DynamicFieldKey.UNKNOWN,
          label: field.label ?? '',
          symbol: field.key ? formatDynamicFieldKey(field.key) : '',
        };

        if (field.property === DynamicFieldProperty_Enum.EVENT_EARLY_AT && field.key) {
          const options = dynamicFieldOptionsMap[field.key];
          if (options) {
            return {
              ...fields,
              label: defaultDynamicFieldLabelMap[field.key] ?? '',
              options: dynamicFieldOptionsMap[field.key],
            };
          }
        }

        // add onCustomSelect function to the Weave Forms Link dynamic field
        if (field.property === DynamicFieldProperty_Enum.FORMS_LINK) {
          return {
            ...fields,
            customSelect: true,
          };
        }

        return fields;
      }),
    [data, defaultDynamicFieldLabelMap, dynamicFieldOptionsMap]
  );

  const bindingsList = data.map((tag) => ({
    property: tag.property ?? DynamicFieldProperty_Enum.UNKNOWN,
    values: tag.exampleValues ?? [],
  }));

  return { bindingsList, dynamicFields };
};
